import React from 'react';
import FormInput from 'components/FormInput';
import { Form } from 'react-bootstrap';
import { useFormik } from 'formik';
import { Footer } from '../Footer';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootStates } from 'redux/store';
import { ProfileSchema } from './schema';
import { useUpdateUserDetailsMutation } from 'redux/services/auth';
import { getHeaders } from 'helper/helper';
import { Loader } from 'components/common/Loader';
import toast from 'react-hot-toast';
import { saveUserDetails } from 'redux/authSlice';
import { useTranslation } from 'react-i18next';

export const ProfileForm: React.FC<{}> = ({ children }) => {
  const { t } = useTranslation();
  const { page = '0' } = useParams();
  const navigate = useNavigate();
  const [updateUserDetails, { isLoading, isError }] =
    useUpdateUserDetailsMutation();
  const user = useSelector((state: RootStates) => state.auth.userDetails);
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      name: user.name ?? '',
      orgName: user.onboardingData?.organization ?? '',
    },
    validationSchema: ProfileSchema,
    onSubmit: async (values) => {
      const headers = await getHeaders();
      const payload: any = await updateUserDetails({
        headers: headers,
        body: {
          name: user.name || values.name,
          onboardingData: {
            ...user.onboardingData,
            name: user.name || values.name,
            organization: values.orgName || '',
            lastPageFilled: page,
          },
        },
      });

      if (!isError) {
        dispatch(saveUserDetails(payload.data));
        if (
          user.onboardingData?.isEmailVerified &&
          user.onboardingData?.isMobileVerified
        ) {
          navigate('/onboarding/2');
        } else {
          navigate(`/onboarding/${Number(page) + 1}`);
        }
      } else {
        toast.error(t('error_project_update_failed'));
      }
    },
  });

  const { errors, touched } = formik;

  return (
    <>
      <h5>{t('onboarding_header1')}</h5>
      <Form onSubmit={formik.handleSubmit}>
        <div className="form-content">
          <div>
            <div>
              <FormInput
                label={t('label_name')}
                type="text"
                name="name"
                value={formik.values.name}
                touched={touched.name}
                error={errors.name}
                onChange={formik.handleChange}
              />
            </div>
          </div>
          <FormInput
            label={t('label_organization_name')}
            type="text"
            name="orgName"
            required={false}
            value={formik.values.orgName}
            touched={touched.orgName}
            error={errors.orgName}
            onChange={formik.handleChange}
          />
        </div>
        <Footer page={Number(page)}>{children}</Footer>
      </Form>
      {isLoading && <Loader />}
    </>
  );
};
